<template>
    <div>
        <div
class="menu-node"
            :style="{ paddingLeft: (24 + depth * 16) + 'px' }"
            :class="{ active: selectedItem === node.asset_code }"
            @click="$emit('node-click', node)">
            <span class="menu-category-icon">
                <i v-if="node.loading" class="pi pi-spin pi-spinner"></i>
                <i v-else :class="node.icon"></i>
            </span>
            <span class="menu-node-label flex-grow-1">{{ node.label }}</span>
            <span v-if="node.has_children" class="menu-sub-arrow">
                <i :class="node.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </span>
        </div>
        <transition name="slide-down">
            <div v-if="node.open && node.children && node.children.length > 0">
                <asset-tree-node
                    v-for="(child, idx) in node.children"
                    :key="child.asset_code || idx"
                    :node="child"
                    :depth="depth + 1"
                    :selected-item="selectedItem"
                    @node-click="$emit('node-click', $event)"
                />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "AssetTreeNode",
    props: {
        node: { type: Object, required: true },
        depth: { type: Number, default: 0 },
        selectedItem: { type: String, default: null },
    },
    emits: ["node-click"],
};
</script>

<style scoped>
.menu-node {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    font-size: 0.8rem;
    color: #67748e;
}

.menu-node:hover {
    color: #344767;
    background: #f8f9fa;
}

.menu-node.active {
    background: #f6f9ff;
    color: #5e72e4;
    font-weight: 600;
}

.menu-node-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.menu-category-icon i {
    font-size: 14px;
    color: #5e72e4;
}

.menu-sub-arrow i {
    font-size: 10px;
    color: #8898aa;
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.2s ease;
    overflow: hidden;
    max-height: 500px;
}

.slide-down-enter-from,
.slide-down-leave-to {
    max-height: 0;
    opacity: 0;
}
</style>
